import React from 'react';
import i18n from 'micro-i18n';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/error/Error.scss';

const Error = () => {
  return (
    <div className="csw-err">
      {i18n.t('ERROR')}
    </div>
  );
};

export default Error;
